export enum ElementRisposte {
    question = 'question',
    answer = 'answer'
}